module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","msg":{"yay":"Yay!","oops":"Oops!","success":"Your registration has been completed successfully. Please check your inbox."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/locales/en.json
// module id = 1347
// module chunks = 0